import React, { useState } from 'react';
import { exportCasePacketToPdf } from '../../utils/pdfExport';

function OutputCard({ title, content, copyable = true }) {
  const [copied, setCopied] = useState(false);

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(content);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Copy failed:', err);
    }
  }

  return (
    <div className="ff-output-card">
      <div className="ff-output-header">
        <h3>{title}</h3>
        {copyable && content && (
          <button 
            className="ff-copy-btn"
            onClick={handleCopy}
            data-testid={`copy-${title.toLowerCase().replace(/\s/g, '-')}`}
          >
            {copied ? '✓ Copied' : '📋 Copy'}
          </button>
        )}
      </div>
      <div className="ff-output-content">
        {content || <span className="ff-placeholder">Not generated yet.</span>}
      </div>
    </div>
  );
}

function OutputsPanel({ analysis, caseData, showPacketSummary = false, onExportTracked }) {
  if (!analysis) {
    return null;
  }

  function handleExportPdf() {
    if (onExportTracked) onExportTracked();
    exportCasePacketToPdf({ analysis, caseData });
  }

  return (
    <div className="ff-outputs" data-testid="outputs-panel">
      <div className="ff-outputs-header">
        <h2>Generated Outputs</h2>
        <button 
          className="ff-btn-primary"
          onClick={handleExportPdf}
          data-testid="export-pdf-btn"
        >
          Export PDF
        </button>
      </div>

      {/* Urgency Badge */}
      {analysis.urgency && (
        <div className={`ff-urgency-badge ff-urgency-${analysis.urgency}`}>
          Urgency: {analysis.urgency.toUpperCase()}
        </div>
      )}

      {/* Possible Issues */}
      {analysis.possible_issues?.length > 0 && (
        <div className="ff-possible-issues">
          <h3>Possible Issues Identified</h3>
          <ul>
            {analysis.possible_issues.map((issue, idx) => (
              <li key={idx}>{issue}</li>
            ))}
          </ul>
        </div>
      )}

      <div className="ff-outputs-grid">
        <OutputCard 
          title="Fact Summary" 
          content={analysis.summary}
        />
        
        <OutputCard 
          title="Statement Draft" 
          content={analysis.statement_draft}
        />
        
        <OutputCard 
          title="Meeting Prep Sheet" 
          content={analysis.meeting_prep_sheet}
        />

        {showPacketSummary && analysis.documentation_packet_summary && (
          <OutputCard 
            title="Documentation Packet Summary" 
            content={analysis.documentation_packet_summary}
          />
        )}
      </div>
    </div>
  );
}

export default OutputsPanel;
